import { DashboardAdd } from "./model/DashboardAdd";
var DashboardAddStore = new DashboardAdd();
export { DashboardAddStore };
